/**
 * Format an ISO timestamp into a human-friendly "time ago" string.
 * e.g. "just now", "5m ago", "3h ago", "2d ago", "3w ago", "5mo ago", "1y ago".
 */
export function timeAgo(iso) {
  if (!iso) return '';
  let then;
  try {
    then = new Date(iso);
    if (isNaN(then.getTime())) return '';
  } catch {
    return '';
  }
  const seconds = Math.floor((Date.now() - then.getTime()) / 1000);
  if (seconds < 0) return 'just now';
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return `${weeks}w ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  const years = Math.floor(days / 365);
  return `${years}y ago`;
}

/** Whether a listing is "new" (< 24 hours old). */
export function isNewListing(iso) {
  if (!iso) return false;
  try {
    const ageHours = (Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60);
    return ageHours >= 0 && ageHours < 24;
  } catch {
    return false;
  }
}
